"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthScope = exports.AuthType = void 0;
/**
 * Authentication types we support
 */
var AuthType;
(function (AuthType) {
    /**
     * Using the Authorization header: "Authorization: Basic"
     */
    AuthType["BASIC"] = "BASIC";
    /**
     * Using the Authorization header: "Authorization: Basic"
     * where the username and password are the partner client ID and
     * client secret
     */
    AuthType["CLIENT_CREDENTIALS"] = "CLIENT_CREDENTIALS";
    /**
     * Using the Authorization header "Authorization: Bearer"
     * This bearer token is the one we generated and store in the accounts database.
     *
     * @example Authorization: Bearer 01234567890-deadbeef-not-a-real-token
     */
    AuthType["BEARER"] = "BEARER";
    /**
     * Using the Authorization header "Authorization: Bearer" that was issued
     * by Cognito to the Seller Portal client id.  This is a JWT token.
     * @example Authorization: Bearer 01234567890-deadbeef-not-a-real-token
     */
    AuthType["BEARER_UI"] = "BEARER_UI";
    /**
     * Using the "X-Shopify-Access-Token" header
     */
    AuthType["TOKEN"] = "TOKEN";
    /**
     * No authorization method provided by client
     */
    AuthType["NONE"] = "NONE";
    /**
     * Authorization is used but scheme is invalid (not Basic)
     */
    AuthType["INVALID"] = "INVALID";
})(AuthType = exports.AuthType || (exports.AuthType = {}));
/**
 * API Scopes
 */
var AuthScope;
(function (AuthScope) {
    AuthScope["PRODUCTS_READ"] = "read_logistics_products";
    AuthScope["PRODUCTS_WRITE"] = "write_logistics_products";
    AuthScope["REPORTS_READ"] = "read_logistics_reports";
    AuthScope["REPORTS_WRITE"] = "write_logistics_reports";
    AuthScope["BUNDLES_READ"] = "read_logistics_bundles";
    AuthScope["BUNDLES_WRITE"] = "write_logistics_bundles";
    AuthScope["ORDERS_READ"] = "read_logistics_orders";
    AuthScope["ORDERS_WRITE"] = "write_logistics_orders";
    AuthScope["WEBHOOKS_READ"] = "read_logistics_webhooks";
    AuthScope["WEBHOOKS_WRITE"] = "write_logistics_webhooks";
    AuthScope["PARCELS_READ"] = "read_logistics_parcels";
    AuthScope["PARCELS_WRITE"] = "write_logistics_parcels";
    AuthScope["RETURNS_READ"] = "read_logistics_returns";
    AuthScope["RETURNS_WRITE"] = "write_logistics_returns";
    AuthScope["FREIGHT_READ"] = "read_logistics_freight";
    AuthScope["FREIGHT_WRITE"] = "write_logistics_freight";
    AuthScope["INBOUNDS_READ"] = "read_logistics_inbounds";
    AuthScope["INBOUNDS_WRITE"] = "write_logistics_inbounds";
    AuthScope["ORDERS_B2B_READ"] = "read_logistics_orders_b2b";
    AuthScope["ORDERS_B2B_WRITE"] = "write_logistics_orders_b2b";
    // There is no API to write events at this time
    // EVENTS_WRITE = "write_logistics_events",
    AuthScope["EVENTS_READ"] = "read_logistics_events";
    AuthScope["UPLOADS_WRITE"] = "write_logistics_uploads";
    AuthScope["CHANNELS_READ"] = "read_logistics_channels";
    AuthScope["CHANNELS_WRITE"] = "write_logistics_channels";
    /**
     * The scopes below that start with internal_ are for internal access only,
     * not available to customers.  They may allow cross-tenant access, or other
     * functionality not available to customers.
     */
    AuthScope["INTERNAL_USERS_READ"] = "internal_read_users";
    AuthScope["INTERNAL_USERS_WRITE"] = "internal_write_users";
})(AuthScope = exports.AuthScope || (exports.AuthScope = {}));
//# sourceMappingURL=Auth.js.map